import script from "./LunchBuffet.vue?vue&type=script&setup=true&lang=js"
export * from "./LunchBuffet.vue?vue&type=script&setup=true&lang=js"

import "./LunchBuffet.vue?vue&type=style&index=0&id=62ae1e88&lang=css"

const __exports__ = script;

export default __exports__